'use client';

import { FC } from 'react';
import Calculator from './Calculator';
import { useCalculatorContext } from './CalculatorContext';
const CalculatorClientWrapper: FC = () => {
  const {
    progress
  } = useCalculatorContext();
  return <Calculator progress={progress} data-sentry-element="Calculator" data-sentry-component="CalculatorClientWrapper" data-sentry-source-file="CalculatorClientWrapper.tsx" />;
};
export default CalculatorClientWrapper;